<template>
  <div style="clear: both;" :class="myClass">
    <span class="text-white text-h6">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'flagsNotifier',
  props: {
    message: {
      type: String
    },
    color: {
      type: String
    }
  },
  computed: {
    myClass: function() {
      return this.color.concat(' text-center')
    }
  }
}
</script>

<style scoped></style>
